<div class="no-support">
  <div class="header">
    <h2 mat-dialog-title>
      <span>Oops, this browser is out of date.</span>
    </h2>
    <a href="javascript:void(0)" class="close-icon" (click)="onNoClick()" title="close">
      <mat-icon>close</mat-icon>
    </a>
  </div>
  <mat-dialog-content>
    <div class="ie-no-support">
      <span>The version of</span>
      <span aria-hidden="true" class="logo ie"></span>
      <span class="name">Internet Explorer</span>
      <span>is not supported by MyLion</span>
    </div>
    <div class="supported-browsers">
      <p class="note">Download one of the free browsers below.</p>
      <ul class="list">
        <li>
          <span class="logo chrome"></span>
          <a href="https://www.google.com/chrome/" target="_blank" class="name">Google Chrome</a>
        </li>
        <li>
          <span class="logo firefox"></span>
          <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank" class="name">Mozilla Firefox</a>
        </li>
        <li>
          <span class="logo edge"></span>
          <a href="https://www.microsoft.com/en-us/edge" target="_blank" class="name">Microsoft Edge</a>
        </li>
      </ul>
    </div>
    <div class="support">
      <p>Having technical difficulties?</p>
      <div class="action">
        <button (click)="openSupport()" class="btn btn-primary">Lions Support Center</button>
        <button class="btn btn-link" (click)="onNoClick()">Continue Anyway</button>
      </div>
    </div>
  </mat-dialog-content>
</div>